<div class="address-autocomplete">
  <ng-container *ngIf="!searchResults">
    <div class="address-autocomplete__nsr">
      <div *ngIf="!isSearching">
        <div>
          <ion-label>Post Code:</ion-label>
          <input
            placeholder="Post Code"
            class="form-control"
            type="text"
            autocomplete="off"
            (change)="addressLine = null"
            [(ngModel)]="postCode"
            (cdkAutofill)="submitSearch(postCode)"
            (keyup.enter)="submitSearch(postCode)" />
        </div>

        <div class="separator">- or -</div>

        <div class="firstLine">
          <ion-label>First line of Address:</ion-label>

          <input
            placeholder="First Line Address"
            class="form-control"
            type="text"
            autocomplete="off"
            (change)="postCode = null"
            [(ngModel)]="addressLine"
            (keyup.enter)="submitSearch(addressLine)" />
        </div>

        <div class="summary__buttons">
          <ion-button (click)="submitSearch(postCode || addressLine)" [disabled]="!postCode && !addressLine">Search</ion-button>

          <a class="link" href="javascript:void(0)" (click)="manual()">Enter Manually</a>
        </div>
      </div>
      <div class="searching" *ngIf="isSearching">
        <ion-spinner></ion-spinner>
        <ion-label> Searching addresses...</ion-label>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="searchResults">
    <div class="address-autocomplete__sr">
      <div class="card">
        <div class="search">
          <div *ngFor="let address of searchResults; trackBy: trackById" tappable (click)="setAddress(address)" class="search-result">
            {{ address.name }}
          </div>
        </div>
        <p class="search" *ngIf="searchResults.length === 0 && !isSearching">No Address found</p>
      </div>

      <div class="summary__buttons">
        <a class="link" href="javascript:void(0);" (click)="clear()" *ngIf="hasResults"> Search Again...</a>
        <a class="link" href="javascript:void(0)" (click)="manual()">Enter Manually</a>
      </div>
    </div>
  </ng-container>
</div>
